import React from 'react';
import {BANNER_TYPE} from "../../../../constants/commons";
import CustomBanner from "../carousel";
import ViewAllTitle from "../../../../components/ViewAllTitle";

const OnGoingCampaigns = ({mobile}) => {
  return (
    <div className="w-full text-rand-100">
      <VaccineBannerWrapper wrap={!mobile} banner={

        <>
          <ViewAllTitle title="Vaccinations" mobile={mobile} titleMargin="mx-10 mt-8"/>

          <CustomBanner bannerType={BANNER_TYPE.campaigns} mobile={mobile} showArrowButton={true}
                        showDotIndicator={true}/>
        </>
      }/>
    </div>

  );
};

const VaccineBannerWrapper = ({banner, wrap = false, mobile}) => {
  return (
    wrap ?
      <div className="flex items-start app-side-pd space-x-4">
        <div className="flex-1">
          <div className="h-[68px]"></div>
          <img src="/images/vaccine_banner.png" alt="vaccine banner"
               className={`image-aspect-ratio force ${mobile ? "app-rounded" : "app-rounded"}`}/>
        </div>
        <div className="flex-1">{banner}</div>
      </div> : banner
  );
};

export default React.memo(OnGoingCampaigns);